import cn from '@/utils/cn';

// Shared by the app tree and every drill rail so their items match.
export const railItemClass = (active: boolean) => cn(
  'tw-flex tw-w-full tw-items-center tw-gap-2 tw-rounded-md tw-px-2 tw-py-1.5',
  'tw-text-sm tw-no-underline tw-box-border',
  active
    ? cn(
      'tw-bg-spa-accent-bg tw-text-spa-accent-text-hover tw-font-medium',
      'hover:tw-text-spa-accent-text-hover hover:tw-no-underline',
    )
    : 'tw-text-spa-primary hover:tw-bg-spa-bg-tertiary hover:tw-text-spa-on-bg hover:tw-no-underline',
);

// A structural row the current page sits inside (its unit or lesson): accent text, no fill, so it
// doesn't merge with the filled row of the page itself right below it.
export const ancestorItemClass = 'tw-font-semibold tw-text-spa-accent-text-hover hover:tw-text-spa-accent-text-hover';

// Pages nested under a node: one step smaller.
export const subItemClass = (active: boolean) => cn(
  'tw-box-border tw-flex tw-w-full tw-items-center tw-rounded-md tw-px-2 tw-py-1 tw-text-[0.8125rem]',
  'tw-border-0 tw-bg-transparent tw-text-left tw-no-underline tw-cursor-pointer',
  active
    ? cn(
      'tw-bg-spa-accent-bg tw-font-medium tw-text-spa-accent-text-hover',
      'hover:tw-text-spa-accent-text-hover hover:tw-no-underline',
    )
    : 'tw-text-spa-secondary hover:tw-bg-spa-bg-tertiary hover:tw-text-spa-on-bg hover:tw-no-underline',
);

// The tree's one indent step: a node's children hang under a hairline that starts in the node's
// chevron gutter, so child text lines up with the parent's title instead of stepping further right.
// The gutter is never narrower than 24px, the WCAG 2.5.8 minimum target, whatever the root font
// size (the SPA's is 16px, the legacy mount's smaller): the chevron button fills it. The hairline
// sits at the gutter's centre.
export const chevronGutterClass = 'tw-flex tw-w-[max(1.5rem,24px)] tw-shrink-0 tw-justify-center tw-text-spa-tertiary';
export const childrenClass = cn(
  'tw-ml-[calc(max(1.5rem,24px)/2_-_1px)] tw-border-0 tw-border-l-2 tw-border-solid tw-border-spa-border',
  'tw-pl-[calc(max(1.5rem,24px)/2_-_1px)]',
);

// A node's pages as a tab row (the lessons page header, the legacy context bar).
export const nodeTabClass = (active: boolean) => cn(
  'tw-box-border tw-inline-flex tw-items-baseline tw-gap-1.5 tw-border-0 tw-border-b-2 tw-border-solid',
  'tw-px-3 tw-py-2 tw-text-sm tw-no-underline hover:tw-no-underline',
  active
    ? 'tw-border-spa-accent tw-font-semibold tw-text-spa-heading hover:tw-text-spa-heading'
    : 'tw-border-transparent tw-text-spa-secondary hover:tw-border-spa-border hover:tw-text-spa-on-bg',
);

export const sectionLabelClass = cn(
  'tw-px-2 tw-pb-1 tw-pt-3 tw-text-[0.6875rem] tw-font-semibold tw-uppercase tw-tracking-wide',
  'tw-text-spa-tertiary',
);
